import { useGame } from '@/store/game';

/**
 * Уход приложения в фон закрывает экран проставкой: телефон мог лечь на стол
 * текстом вверх, а следующий, кто на него взглянет, не обязан быть тем же
 * игроком (CLAUDE.md, инвариант 7). `coverScreen()` в сторе уже знает, что
 * делать в multi (ничего) — здесь только подписка на событие браузера.
 */
export function watchVisibility(): () => void {
  const onChange = (): void => {
    if (document.visibilityState === 'hidden') useGame.getState().coverScreen();
  };
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
}
